import { Avatar, styled } from '@mui/material';
import { useEffect, useState } from 'react';

interface UserAvatarProps {
  fullName: string;
  photoURL?: string;
}

const StyledAvatar = styled(Avatar)`
  background-color: #0080c8;
  color: #ffffff;
  font-weight: 400;
  text-transform: uppercase;
  margin-left: 10px;
  letter-spacing: 0.8px;
`;

// To generate initials from full name
const getInitials = (fullName: string): string => {
  if (!fullName?.trim()) return '?';
  const parts = fullName.trim().split(/\s+/);
  const firstInitial = parts[0][0]?.toUpperCase() || '';
  const lastInitial = parts.length > 1 ? parts[parts.length - 1][0]?.toUpperCase() : '';
  return firstInitial + lastInitial;
};

export default function UserAvatar({ fullName, photoURL }: UserAvatarProps) {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const initials = getInitials(fullName);

  useEffect(() => {
    if (!photoURL) return setIsImageLoaded(false);

    // Preload the image to prevent blinking issue during browser refresh
    const img = new Image();
    img.src = photoURL;

    // On successful load, show image
    img.onload = () => setIsImageLoaded(true);

    // On error, fallback to initials
    img.onerror = () => setIsImageLoaded(false);
  }, [photoURL]);

  return (
    <StyledAvatar alt={fullName} src={isImageLoaded ? photoURL : undefined}>
      {initials}
    </StyledAvatar>
  );
}
